"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var S = _interopRequireWildcard(require("./styled"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Modal = function Modal(_ref) {
  var children = _ref.children,
      title = _ref.title,
      isVisible = _ref.isVisible,
      close = _ref.close,
      buttons = _ref.buttons,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$bodyClassName = _ref.bodyClassName,
      bodyClassName = _ref$bodyClassName === void 0 ? '' : _ref$bodyClassName,
      _ref$hideCloseButton = _ref.hideCloseButton,
      hideCloseButton = _ref$hideCloseButton === void 0 ? false : _ref$hideCloseButton;
  return /*#__PURE__*/_react["default"].createElement(S.Modal, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('modal', {
      visible: isVisible
    }),
    tabIndex: "-1",
    role: "dialog"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-dialog ".concat(className),
    role: "document"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-content",
    "data-testid": "".concat(title.toLowerCase().replaceAll(' ', '-'), "-modal")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-header"
  }, /*#__PURE__*/_react["default"].createElement("h5", {
    className: "modal-title"
  }, title), !hideCloseButton && /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "close",
    "aria-label": "Close",
    onClick: close,
    "data-testid": "close-".concat(title.toLowerCase().replaceAll(' ', '-'))
  }, /*#__PURE__*/_react["default"].createElement("span", {
    "aria-hidden": "true"
  }, "\xD7"))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-body ".concat(bodyClassName)
  }, children), buttons && buttons.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-footer"
  }, buttons.map(function (button, idx) {
    return /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn ".concat(button.type),
      onClick: button.action,
      key: idx,
      disabled: button.disabled,
      "data-testid": "button-action_".concat(button.text.toLowerCase().replaceAll(' ', '-'))
    }, button.text);
  }))))));
};

Modal.propTypes = {
  isVisible: _propTypes["default"].bool.isRequired,
  title: _propTypes["default"].string.isRequired,
  buttons: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    type: _propTypes["default"].string,
    text: _propTypes["default"].string.isRequired,
    action: _propTypes["default"].func.isRequired
  }))
};
var _default = Modal;
exports["default"] = _default;